import React, { useState, useEffect, useCallback } from 'react';
import { useSpring } from 'react-spring';
import { InfoIcon, InfoIconEvolutive } from 'src/components/Icons';
import { Button } from '../../components/Button';
import * as Ui from './styles';

// TODO: documentar
function PromptConfirmEvolutive({
  // informa que o prompt está sendo visível ou não
  isOpen = false,
  // informa que está ocorrendo um processamento e o botão Ok deve refletir isto como microinteração
  isLoading = false,
  // um dos componentes de ícones
  iconComponent,
  // título do prompt
  title,
  // o texto a ser exibido
  text,
  // texto do botão ok
  btnOk,
  // texto do botão cancelar
  btnCancel,
  // evento de acionamento do botão de encerramento ou TODO: de toque fora da tela ou ESC
  onClose,
  // evento de acionamento do botão de confirmação
  onConfirm,
}) {
  // state
  const [isVisible, setVisibility] = useState(false);

  // callbacks
  const handleExitByDOMEvent = useCallback((event) => {
    if (event.keyCode === 27) {
      setVisibility(false);
    }
  }, []);

  // on open or close
  useEffect(() => {
    setVisibility(isOpen);
  }, [isOpen]);

  // change body style
  useEffect(() => {
    document.addEventListener('keydown', handleExitByDOMEvent, false);
    return () => {
      document.removeEventListener('keydown', handleExitByDOMEvent, false);
    };
  });

  // ícone passado via props
  // const Icon = (props) => iconComponent(props);

  // animation
  const animationProps = useSpring({
    from: {
      opacity: isVisible ? 0 : 1,
    },
    to: {
      opacity: isVisible ? 1 : 0,
    },
    onStart: () => {
      if (isVisible) setVisibility(true);
    },
    onRest: () => {
      if (!isVisible) setVisibility(false);
    },
  });

  // handle reset state
  function handleCancel() {
    setVisibility(false);
    if (onClose) onClose();
  }

  // handle accepted file
  function handleOk() {
    if (onConfirm) onConfirm();
    setVisibility(false);
  }

  // conditional render
  if (!isVisible) {
    return null;
  }

  return (
    <Ui.Container style={{ ...animationProps, visibility: isVisible ? 'visible' : 'hidden' }}>
      <Ui.PanelEvolutive>
        <Ui.PanelEvolutiveHeader>
          <InfoIconEvolutive className="iconHeader" />
          <Ui.PanelEvolutiveTitle>{title}</Ui.PanelEvolutiveTitle>
        </Ui.PanelEvolutiveHeader>
        <Ui.PanelEvolutiveBody>
          <Ui.PanelEvolutiveBodyText dangerouslySetInnerHTML={{ __html: text }}></Ui.PanelEvolutiveBodyText>
        </Ui.PanelEvolutiveBody>
        <Ui.PanelEvolutiveActions>
          <Ui.PanelEvolutiveActionCancel type="button" title={btnCancel} onClick={() => handleCancel()}>{btnCancel}</Ui.PanelEvolutiveActionCancel>

          {!isLoading ? <Ui.PanelEvolutiveActionActive type="button" title={btnOk} onClick={() => handleOk()}>{btnOk}</Ui.PanelEvolutiveActionActive> : null}
        </Ui.PanelEvolutiveActions>
      </Ui.PanelEvolutive>
    </Ui.Container>
  );
}

// create an hooker to handle PromptConfirmEvolutive
const usePromptConfirmEvolutive = (() => {
  // states
  const [isOpen, setIsOpen] = useState(false);
  const [onConfirm, setOnConfirm] = useState(null);
  const [onClose, setOnClose] = useState(null);

  const openPromptConfirmEvolutive = useCallback((openCallback, closeCallback) => {
    setIsOpen(true);
    if (openCallback) setOnConfirm(() => openCallback);
    if (closeCallback) setOnClose(() => closeCallback);
  }, []);

  const handleClose = useCallback(() => {
    if (onClose) {
      onClose();
    }
    setIsOpen(false);
  }, [onClose]);

  const handleConfirm = useCallback(() => {
    if (onConfirm) {
      onConfirm();
    }
    setIsOpen(false);
  }, [onConfirm]);

  function renderPromptConfirmEvolutive(title, text, btnOk = 'Excluir', btnCancel = 'Cancelar') {
    return (
      <PromptConfirmEvolutive
        isOpen={isOpen}
        // iconComponent={icon}
        title={title}
        text={text}
        btnOk={btnOk}
        btnCancel={btnCancel}
        onClose={handleClose}
        onConfirm={handleConfirm}
      />
    );
  }

  return [
    openPromptConfirmEvolutive,
    renderPromptConfirmEvolutive,
  ];
});

export { PromptConfirmEvolutive, usePromptConfirmEvolutive };
